import { AttributesListItem } from 'src/utils/createAttributesItem.ts';

export const filterEmpty = (item: AttributesListItem | null): boolean => {
    if (!item) {
        return false;
    }
    const [, value] = item;
    return !!value;
};
